export
const name: string = "ApplyTextureToSurface";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform         lowp sampler2D u_texture;
    uniform         lowp int       u_texture_model;
    uniform         lowp vec3      u_texture_blend_color;
    uniform         mediump vec2   u_texture_dimensions;
    uniform         lowp int       u_texture_lod_debug;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    SMaterial applyTextureToSurface(in SMaterial aMaterial, in vec2  aTextureCoord)
    {
        SMaterial mat = aMaterial;

        if (u_texture_model != TEX_MODEL_NONE) {
            lowp vec4 texColor = texture2D(u_texture, aTextureCoord);
            mat.texColorReadOnly = texColor.rgb;

            if (u_texture_model == TEX_MODEL_REPLACE) {
                mat.ambient = vec3(0.0);
                mat.diffuse = texColor.rgb;

                // color the texture depending on its resolution (expect square i.e. e.g. 1024x1024 textures)
                if (u_texture_lod_debug > 0) {
                    float biggerDim = max(u_texture_dimensions.x, u_texture_dimensions.y) + 0.5;
                    if (biggerDim >= 2048.0) {
                        mat.diffuse = texColor.rgb * vec3(0.0, 0.0, 1.0);
                    }
                    else if (biggerDim >= 1024.0) {
                        mat.diffuse = texColor.rgb * vec3(0.0, 1.0, 0.0);
                    }
                    else if (biggerDim >= 512.0) {
                        mat.diffuse = texColor.rgb * vec3(1.0, 0.0, 0.0);
                    }
                    else if (biggerDim >= 256.0) {
                        mat.diffuse = texColor.rgb * vec3(1.0, 0.1, 1.0);
                    }
                }

                mat.alpha = texColor.a;
                mat.shading = 0; // force shading to be no shading
            }
            else if (u_texture_model == TEX_MODEL_MODULATE) {
                mat.diffuse = aMaterial.diffuse * texColor.rgb;
                mat.alpha   = texColor.a;
            }
            else if (u_texture_model == TEX_MODEL_CADWORK_MODULATE) {
                // this model ignores the diffuse color
                mat.diffuse = texColor.rgb;
                mat.alpha   = texColor.a;
            }
            else if (u_texture_model == TEX_MODEL_BLEND) {
                mat.diffuse = u_texture_blend_color * texColor.rgb;
                mat.alpha   = texColor.a;
            }
        }

        return mat;

    }
`;
